"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lp_components_1 = require("lp-components");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const components_1 = require("components");
const config_1 = require("config");
const utils_1 = require("utils");
const forms_1 = require("../forms");
const PrintReceiptButton = ({ transactionId, status, ssnLast4, callback, productType, getSalesReceipt, getSalesReceiptSigned, createReceipt, signReceiptV2, identificationConfirmation, setShowMissingIDExpirationModal, submissionFromModal, shownMissingIDExpirationModal, invalid, transactionType = '', }) => {
    // State
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [receiptSuccess, setReceiptSuccess] = (0, react_1.useState)(false);
    const [printStatus, setPrintStatus] = (0, react_1.useState)(status);
    const isDigitalReceiptSale = identificationConfirmation?.type === 'digital-receipt';
    function normalizeDate(dateStr) {
        // If the date is in the format of MM/DD/YYYY, normalize it to YYYY-MM-DD
        if (dateStr.includes('/')) {
            const [month, day, year] = dateStr.split('/');
            if (!month || !day || !year) {
                throw new Error('Invalid date format. Expected MM/DD/YYYY');
            }
            const paddedMonth = month.padStart(2, '0');
            const paddedDay = day.padStart(2, '0');
            return `${year}-${paddedMonth}-${paddedDay}`;
        }
        return dateStr;
    }
    const handlePrintModal = (transactionId) => {
        if (transactionId) {
            setIsOpen(true);
        }
    };
    // Print Normal
    const handlePrint = (transactionId) => {
        setLoading(true);
        getSalesReceipt(transactionId)
            .then((pdfWindowURL) => {
            (0, utils_1.windowOpenAndPrint)(pdfWindowURL); // Print
        })
            .catch(() => {
            (0, utils_1.toastError)('PDF download and print failed');
        })
            .finally(() => setLoading(false));
    };
    // Print Signed Version
    const handlePrintSigned = async (transactionId) => {
        setLoading(true);
        await getSalesReceiptSigned(transactionId)
            .then((pdfWindowURL) => {
            (0, utils_1.windowOpenAndPrint)(pdfWindowURL); // Print
        })
            .catch(() => {
            (0, utils_1.toastError)('PDF download and print failed');
        })
            .finally(() => {
            setLoading(false);
            if (callback) {
                callback(); // Reload page/data
            }
        });
    };
    const handleCreateAndSignReceipt = async (transactionId, identificationConfirmation, updateIdConfirmation) => {
        // Display PDF
        if (setShowMissingIDExpirationModal &&
            !identificationConfirmation?.idExpirationDate &&
            !shownMissingIDExpirationModal) {
            setShowMissingIDExpirationModal(true);
            return;
        }
        setLoading(true);
        const communicationMethod = 'print';
        try {
            const respCreateReceipt = await createReceipt(transactionId, communicationMethod); // Create Receipts
            const normalizedIdExpirationDate = identificationConfirmation?.idExpirationDate
                ? normalizeDate(identificationConfirmation?.idExpirationDate)
                : undefined;
            const signReceiptRequest = {
                transactionId: transactionId,
                receiptId: Number(respCreateReceipt.receiptId),
                ssnLastFour: ssnLast4,
                ...(identificationConfirmation
                    ? {
                        identificationConfirmation: {
                            ...identificationConfirmation,
                            ...(normalizedIdExpirationDate
                                ? { idExpirationDate: normalizedIdExpirationDate }
                                : {}),
                        },
                    }
                    : {}),
                updateIdConfirmation,
            };
            await signReceiptV2(signReceiptRequest); // Sign Receipt v2
            await handlePrintSigned(transactionId);
        }
        catch (e) {
            const message = e.response?.errorCode;
            if (message === 'already_signed') {
                await handlePrintSigned(transactionId);
            }
            setReceiptSuccess(true);
            setPrintStatus('signed');
            setLoading(false);
        }
        setReceiptSuccess(true);
        setPrintStatus('signed');
        setLoading(false);
    };
    const onRequestClose = () => {
        setIsOpen(false);
        setReceiptSuccess(false);
        if (callback) {
            callback(); // Reload page/data
        }
    };
    (0, react_1.useEffect)(() => {
        if (submissionFromModal) {
            const updatedIdentificationConfirmation = {
                ...identificationConfirmation,
                ...(submissionFromModal !== 'empty' && {
                    idExpirationDate: submissionFromModal,
                }),
            };
            handleCreateAndSignReceipt(transactionId, identificationConfirmation
                ? updatedIdentificationConfirmation
                : undefined, true);
        }
    }, [submissionFromModal]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(lp_components_1.Button, { className: "button-primary button-warn print-receipt-button", invalid: loading || invalid, submitting: loading, onClick: () => {
                    if (productType != config_1.PRODUCT_TYPE_MAP.installment &&
                        (printStatus === 'pending_signature' ||
                            (isDigitalReceiptSale && printStatus === 'approved'))) {
                        handlePrintModal(transactionId); // Create and Sign (MC-1394)
                    }
                    else if (transactionType === 'refund' ||
                        printStatus === 'signed' ||
                        printStatus === 'settled' ||
                        ((printStatus === 'pending_signature' ||
                            printStatus === 'sent_for_settlement') &&
                            productType === config_1.PRODUCT_TYPE_MAP.installment)) {
                        handlePrint(transactionId);
                    }
                    else {
                        handleCreateAndSignReceipt(transactionId, identificationConfirmation ?? undefined, true);
                    }
                }, children: "PRINT RECEIPT" }), (0, jsx_runtime_1.jsx)(components_1.Modal, { isOpen: isOpen, setIsOpen: setIsOpen, onRequestClose: onRequestClose, contentClassName: "with-handle", children: receiptSuccess ? ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(components_1.H1, { variant: "headline-large", className: "text-center", children: "Receipt Now Available" }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsxs)("div", { className: "attention-paragraph", children: [(0, jsx_runtime_1.jsx)("span", { className: "icon-text-attention", role: "img", "aria-label": "Attention", children: "!" }), (0, jsx_runtime_1.jsx)(components_1.P, { children: loading
                                        ? 'Your receipt is being prepared for download...'
                                        : 'Your receipt can now be downloaded and signed in person.' })] }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(lp_components_1.Button, { className: "button-primary button-warn print-receipt-button", invalid: loading, submitting: loading, onClick: () => {
                                handlePrintSigned(transactionId);
                            }, children: "PRINT RECEIPT" }), (0, jsx_runtime_1.jsx)(lp_components_1.Button, { className: "button-warn-outline", type: "button", onClick: onRequestClose, children: "CLOSE" })] })) : ((0, jsx_runtime_1.jsx)(forms_1.PrintDigitalReceiptForm, { handleCreateAndSignReceipt: handleCreateAndSignReceipt, onRequestClose: onRequestClose, transactionId: transactionId })) })] }));
};
function mapStateToProps() {
    return {};
}
const mapApiAuthToProps = {
    getSalesReceipt: apiActions.getSalesReceipt,
    getSalesReceiptSigned: apiActions.getSalesReceiptSigned,
    signReceiptV2: apiActions.signReceiptV2,
    createReceipt: apiActions.createReceipt,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(PrintReceiptButton);
